"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthClientError = void 0;
class AuthClientError extends Error {
    constructor(options) {
        super();
        this.code = options.code;
        if (options.code === 'NETWORK_ERROR')
            this.status = options.status;
    }
}
exports.AuthClientError = AuthClientError;
